import { MutationTree } from "vuex";
import {
  AgentPricingResponse,
  IAgentState,
} from "@/core/interfaces/state/agentState.interface";
import { IAgentDetail, IAgentDetails } from "@/core/interfaces/agent.interface";
import { IPaginationMeta } from "@/core/interfaces/state/paginationMeta.interface";

const mutations: MutationTree<IAgentState> = {
  fetchingOrganizationUsers(state, fetching: boolean) {
    state.isFetchingOrganizationUsers = fetching;
  },
  saveOrganizationUsers(state, users: Array<IAgentDetails>) {
    state.organization_users = users;
  },
  saveOrganizationAgents(state, agents: Array<IAgentDetail>) {
    state.isFetchingAgents = false;
    state.organization_agents = agents;
  },
  fetchingAgent(state, fetching: boolean) {
    state.isFetchingAgent = fetching;
  },
  fetchAgentSuccess(state, agent: IAgentDetails) {
    state.isFetchingAgent = false;
    state.organization_user = agent;
  },
  updatingAgentPermissions(state, updating: boolean) {
    state.isUpdatingAgentPermissions = updating;
  },
  updateAgentPermissionsSuccess(state, agent: IAgentDetails) {
    state.isUpdatingAgentPermissions = false;
    state.organization_user = agent;
  },

  saveAgentPricingResponse(state, payload: AgentPricingResponse | null) {
    state.agentPricingResponse = payload;
  },

  setOrganizationAgentsPaginationMeta(
    state,
    paginationMeta: IPaginationMeta | null,
  ) {
    state.organizationAgentsPaginationMeta = paginationMeta;
  },
  resetOrganizationAgentsPagination(state) {
    state.organizationAgentsPaginationMeta = null;
  },

  updateAgentPricingResponse(state, payload: AgentPricingResponse) {
    if (state.agentPricingResponse) {
      state.agentPricingResponse.organization_user_pricing_public_id =
        payload.organization_user_pricing_public_id;
      state.agentPricingResponse.organization_user_pricing_type =
        payload.organization_user_pricing_type;
      state.agentPricingResponse.organization_user_pricing_financial_profile =
        payload.organization_user_pricing_financial_profile;
      state.agentPricingResponse.global_pricing_data =
        payload.global_pricing_data;
      state.agentPricingResponse.default_pricing_data =
        payload.default_pricing_data;
      state.agentPricingResponse.organization_user_pricing_line_data =
        payload.organization_user_pricing_line_data;
    }
  },
};

export default mutations;
